/* GENERATED wrapper kept stable; glyph bodies come from glyph-data.ts. */
import type { SVGProps } from "react";

import { GLYPH_RENDERERS } from "./glyph-data.ts";
import type { IconName } from "./icon-names.ts";

export type IconProps = {
  readonly name: IconName;
  readonly size?: number | string;
} & Omit<SVGProps<SVGSVGElement>, "children" | "width" | "height" | "viewBox" | "name">;

const OUTLINE_DEFAULTS = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** Shared SVG host for outline glyphs, pins, and badges. */
export function Icon({ name, size = 16, className, style, ...rest }: IconProps) {
  const renderer = GLYPH_RENDERERS[name];
  const isOutline = !name.startsWith("pin-") && !name.startsWith("badge-");
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      className={className}
      style={style}
      {...(isOutline ? OUTLINE_DEFAULTS : {})}
      {...rest}
    >
      {renderer()}
    </svg>
  );
}
